import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllRecordings,
  fetchRoomRecordingsApi,
  startRecordingApi,
  stopRecordingApi,
  downloadRecordingApi,
  getRecordingsFromDbApi,
} from "../../../api/recordings";

export const fetchRecordingsAction = createAsyncThunk(
  "recording/fetchRecordingsAction",
  async (_, { rejectWithValue }) => {
    try {
      const data = await getAllRecordings();
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || "Failed to fetch recordings");
    }
  }
);

export const fetchRoomRecordingsAction = createAsyncThunk(
  "recording/fetchRoomRecordingsAction",
  async (arg, { rejectWithValue }) => {
    // Accepts a bare roomSid (legacy, unchanged) or { roomSid, roomKind }.
    const roomSid = typeof arg === "string" ? arg : arg?.roomSid;
    const roomKind = typeof arg === "string" ? null : arg?.roomKind ?? null;
    try {
      const data = await fetchRoomRecordingsApi(roomSid, roomKind);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || "Failed to fetch room recordings");
    }
  }
);

export const toggleRecordingAction = createAsyncThunk(
  "recording/toggleRecordingAction",
  async ({ sid, action }, { rejectWithValue }) => {
    try {
      let data;
      if (action === "start") {
        data = await startRecordingApi(sid);
      } else {
        data = await stopRecordingApi(sid);
      }
      return { ...data, action };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || "Failed to toggle recording");
    }
  }
);

export const downloadRecordingAction = createAsyncThunk(
  "recording/downloadRecordingAction",
  async (sid, { rejectWithValue }) => {
    try {
      const data = await downloadRecordingApi(sid);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || "Failed to download recording");
    }
  }
);

export const getRecordingsFromDbAction = createAsyncThunk(
  "recording/getRecordingsFromDbAction",
  async (sid, { rejectWithValue }) => {
    try {
      const data = await getRecordingsFromDbApi(sid);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || "Failed to fetch recordings from DB");
    }
  }
);

// Backward-compatible aliases (pages use these names)
export const fetchRecordings = fetchRecordingsAction;
export const fetchRoomRecordings = fetchRoomRecordingsAction;
export const toggleRecording = toggleRecordingAction;
